import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-mobile-overlay, .navigation-status-indicator, .navigation-mobile-link {
  transition: none;
  animation: none;
}
.navigation-mobile-overlay.is-open {
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <div className="navigation-main">
            <a href="/">
              <div
                aria-label="Clementine Nexus Home"
                className="navigation-brand"
              >
                <div className="navigation-logo-mark"></div>
                <span className="section-title">Clementine Nexus</span>
              </div>
            </a>
            <div className="navigation-desktop-links">
              <a href="/">
                <div className="navigation-link">
                  <span>Persona</span>
                </div>
              </a>
              <a href="/about-clementine-story">
                <div className="navigation-link">
                  <span>The Story</span>
                </div>
              </a>
              <a href="/book-a-call-contact">
                <div className="navigation-link">
                  <span>Collaborate</span>
                </div>
              </a>
            </div>
          </div>
          <aside className="navigation-sidebar">
            <div className="navigation-status">
              <div className="navigation-status-indicator"></div>
              <span className="navigation-status-text">
                Clementine is online
              </span>
            </div>
            <button
              id="navToggle"
              aria-expanded="false"
              aria-label="Toggle navigation menu"
              className="navigation-mobile-toggle"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 8h16M4 16h16"
                ></path>
              </svg>
            </button>
          </aside>
        </div>
      </nav>
      <div id="mobileMenu" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <a href="/">
            <div
              aria-label="Clementine Nexus Home"
              className="navigation-brand"
            >
              <div className="navigation-logo-mark"></div>
              <span className="section-title">Clementine Nexus</span>
            </div>
          </a>
          <button
            id="navClose"
            aria-label="Close navigation menu"
            className="navigation-close-btn"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15 3v18M8 9l3 3l-3 3"
              ></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <div className="navigation-mobile-list">
            <a href="/">
              <div className="navigation-mobile-link">
                <span className="navigation-link-num">01</span>
                <span className="navigation-link-text">Persona</span>
              </div>
            </a>
            <a href="/about-clementine-story">
              <div className="navigation-mobile-link">
                <span className="navigation-link-num">02</span>
                <span className="navigation-link-text">The Story</span>
              </div>
            </a>
            <a href="/book-a-call-contact">
              <div className="navigation-mobile-link">
                <span className="navigation-link-num">03</span>
                <span className="navigation-link-text">Collaborate</span>
              </div>
            </a>
          </div>
          <div className="navigation-overlay-footer">
            <p className="section-content">Synthetic Teammate Persona v2.0</p>
            <a href="/book-a-call-contact">
              <div className="btn btn-primary btn-lg">
                <span>
                  {' '}
                  Start Conversation
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 12h14m-7-7l7 7l-7 7"
                  ></path>
                </svg>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<style>
        @keyframes pulse {0% {transform: scale(1);
opacity: 1;}
50% {transform: scale(1.2);
opacity: 0.7;}
100% {transform: scale(1);
opacity: 1;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="navigation-container6">
        <div className="navigation-container7">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const navToggle = document.getElementById("navToggle")
  const navClose = document.getElementById("navClose")
  const mobileMenu = document.getElementById("mobileMenu")
  const mobileLinks = document.querySelectorAll(".navigation-mobile-link")

  const openMenu = () => {
    mobileMenu.classList.add("is-open")
    navToggle.setAttribute("aria-expanded", "true")
    document.body.style.overflow = "hidden"
  }

  const closeMenu = () => {
    mobileMenu.classList.remove("is-open")
    navToggle.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""
  }

  navToggle.addEventListener("click", openMenu)
  navClose.addEventListener("click", closeMenu)

  mobileLinks.forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileMenu.classList.contains("is-open")) {
      closeMenu()
    }
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
